import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function upsertUnitType(payload) {
  return mutate(
    {
      unitTypes: [payload],
    },
    gql`
      mutation Upsert_unit_types($unitTypes: [unit_types_input]) {
        upsert_unit_types(unit_types: $unitTypes) {
          id
        }
      }
    `,
  )
}

export async function deleteUnitType(id) {
  return mutate(
    {
      deleteUnitTypesId: id,
    },
    gql`
      mutation Delete_unit_types($deleteUnitTypesId: Int!) {
        delete_unit_types(id: $deleteUnitTypesId) {
          id
        }
      }
    `,
  )
}

export async function upsertUnitTypesConfiguration(values) {
  return mutate(
    {
      unitTypesConfigurationOptions: [values],
    },
    gql`
      mutation Upsert_unit_types_configuration_options(
        $unitTypesConfigurationOptions: [unit_types_configuration_options_input]
      ) {
        upsert_unit_types_configuration_options(unit_types_configuration_options: $unitTypesConfigurationOptions) {
          id
          is_active
        }
      }
    `,
  )
}

export async function deleteUnitTypesConfiguration(id) {
  return mutate(
    {
      deleteUnitTypesConfigurationOptionsId: id,
    },
    gql`
      mutation Delete_unit_types_configuration_options($deleteUnitTypesConfigurationOptionsId: Int!) {
        delete_unit_types_configuration_options(id: $deleteUnitTypesConfigurationOptionsId) {
          id
        }
      }
    `,
  )
}

export async function getUnitTypesConfigurationOptionsFields(client) {
  const { data } = await query(gql`
    query {
      __type(name: "unit_types_configuration_options") {
        fields {
          name
          type {
            name
            kind
          }
        }
      }
    }
  `)
  return data.__type.fields.filter((f) => f.name !== '__typename')
}
